import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { List, Search, Link, Close } from "@mui/icons-material";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import clsx from "clsx";
import {
  Grid,
  Tooltip,
  Box,
  Alert,
  Card,
  TextField,
  Snackbar,
  ClickAwayListener,
  Slide,
} from "@mui/material";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import Moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

import NewLinkPaymentsAdmin from "views/Dialog/NewLinkPaymentsAdmin";
import ViewsTrasactionsPayment from "views/Dialog/ViewsTrasactionsPayment";
import StatusRefundLinkAdmin from "views/Dialog/StatusRefundLinkAdmin";
import ViewLinkAdmin from "views/Dialog/ViewLinkAdmin";
import LoadClients from "components/Services/LoadClients";

import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  ButtonTableGrid2,
  ButtonTableGrid1,
  blackColor,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function RefundsAll() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [totalBalance, setTotalBalance] = useState("0.00");
  const [totalOutstandingBalance, setTotalOutstandingBalance] =
    useState("0.00");
  const [totalTransitBalance, setTotalTransitBalance] = useState("0.00");
  const [mensageSystem, setMensageSystem] = useState("");
  const [openSnackbar, setOpenSnackbar] = React.useState({
    mensage: "",
    open: false,
  });
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [dateStart, setDateStart] = useState(false);
  const [dateEnd, setDateEnd] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const [openRefund, setOpenRefund] = useState(false);

  let resultSearch = "";

  const { urlServices, UserAuth, urlWeb } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    endLink: null,
    startLink: null,
    clients: null,
    clientsData: "",
  });

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "reference",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 12, color: blackColor }}
              >{`${params.row.reference}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Cliente",
        field: "client",
        headerAlign: "center",
        width: 200,
        // align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 14, color: blackColor }}
              >{`${params.row?.client?.companyName}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Cliente del hotel",
        field: "name",
        // headerAlign: "center",
        width: 300,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "3px", // Espacio opcional entre los elementos
                margin: "8px 0",
              }}
            >
              <div
                style={{ fontSize: 14, color: blackColor, fontWeight: "bold" }}
              >
                {`${params.row?.name} ${params.row.lastName}`}
              </div>
              <div style={{ fontSize: 10, color: "#333" }}>
                <b>Documento ID:</b> {`${params.row?.documentId}`}
              </div>
              <div style={{ fontSize: 10, color: "#333" }}>
                <b>Email:</b> {`${params.row?.email}`}
              </div>
            </div>
          );
        },
      },
      {
        headerName: "Descripción",
        field: "description",
        headerAlign: "center",
        width: 250,
        // align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 12 }}
              >{`${params.row.description}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Total",
        field: "commissionPayment",
        headerAlign: "center",
        width: 110,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "3px", // Espacio opcional entre los elementos
                margin: "8px 0",
              }}
            >
              <div style={{ fontSize: 14, color: "green", fontWeight: "bold" }}>
                {`$${(parseFloat(params.row?.commissionPayment) + parseFloat(params.row?.commissionPaymentTotal)).toFixed(2)}`}
              </div>
            </div>
          );
        },
      },
      {
        headerName: "---",
        field: "slug",
        headerClassName: "super-app-theme--header",
        width: 120,
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Grid
              container
              sx={{
                display: parseInt(params.row.status) === 2 ? "none" : "block",
              }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display:
                    params.row.paymentTransactions?.length > 0
                      ? "block"
                      : "none",
                }}
              >
                <ButtonTableGrid1
                  onClick={handleDetails(params)}
                  style={{
                    margin: "5px 0",
                    fontSize: 10,
                    width: "100%",
                    padding: "6px 8px",
                  }}
                >
                  Ver transacción
                </ButtonTableGrid1>
              </Grid>
            </Grid>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "----",
        field: "status",
        headerAlign: "center",
        width: 130,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          let refunds = params.row?.refunds
            ? JSON.parse(params.row.refunds)
            : null;
          return (
            <Grid container>
              <Grid item xs={12} sm={12}>
                {!refunds?.admin ? (
                  <ButtonTableGrid2
                    onClick={handlePaidRefundsValue(params)}
                    style={{ margin: "5px 0", fontSize: 10, width: 90 }}
                  >
                    HACER REEMBOLSO
                  </ButtonTableGrid2>
                ) : (
                  <ButtonTableGrid2
                    onClick={openViewValue(params)}
                    ariant="text"
                    style={{
                      margin: "5px 0",
                      fontSize: 10,
                      width: 90,
                      background: "green",
                      color: "white",
                    }}
                  >
                    REEMBOLSO REALIZADO
                  </ButtonTableGrid2>
                )}
              </Grid>
            </Grid>
          );
        },
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>
              {params.value
                ? Moment(params.value).format("DD-MM-YYYY")
                : ""}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 100,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 130,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Ver registro" arrow>
                  <Search style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Ver registro"
              onClick={openViewValue(params)}
            />,
          );

          /*  if (parseInt(params.row.status) === 99) {
            // Si el perfil está deshabilitado, mostramos el icono para habilitarlo
            actions.push(
              /* <GridActionsCellItem
                      key="enable"
                      icon={
                        <Tooltip title="Habilitar" arrow>
                          <AddCircle style={{ fontSize: 24, color: "green" }} />
                        </Tooltip>
                      }
                      label="Habilitar"
                      onClick={openStatusValue(params)}
                    />*/
          /*  <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                style={{
                  marginLeft: "-9px",
                  display:
                    parseInt(params.row.status) === 2 ||
                    parseInt(params.row.status) === 3
                      ? "none"
                      : "block",
                }}
              >
                <Tooltip title="Habilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 99 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params, 1)}
                  />
                </Tooltip>
              </Stack>
            );
          } else {
            // Si el perfil está habilitado, mostramos el icono para deshabilitarlo
            actions.push(
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                style={{
                  marginLeft: "-9px",
                  display:
                    parseInt(params.row.status) === 2 ||
                    parseInt(params.row.status) === 3
                      ? "none"
                      : "block",
                }}
              >
                <Tooltip title="Deshabilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 99 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params, 99)}
                  />
                </Tooltip>
              </Stack>
            );
          }

         actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Eliminar" arrow>
                  <HighlightOffOutlined
                    style={{ fontSize: 24, color: "red" }}
                  />
                </Tooltip>
              }
              style={{
                display: parseInt(params.row.status) === 3 ? "none" : "block",
              }}
              label="Eliminar"
              onClick={openStatusValue(params, 0)}
            />
          );*/
          return actions;
        },
      },
    ],
  });

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleCopy = () => {
    setOpenSnackbar({ mensage: "Link copiado al portapapeles!", open: true });
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchText(searchValue);

    if (searchValue.trim() !== "") {
      const searchLower = removeAccents(searchValue.toLowerCase());

      resultSearch = rows.filter((item) => {
        // Búsqueda por nombre de proveedor
        const nameMatch = removeAccents(item.name.toLowerCase() || "").includes(
          searchLower,
        );

        // Búsqueda por nombre de aplicación
        const lastNameMatch = item.lastname
          ?.toLowerCase()
          .includes(searchLower);

        const documentMatch = item.documentId
          ?.toLowerCase()
          .includes(searchLower);

        const descriptionMatch = item.description
          ?.toLowerCase()
          .includes(searchLower);
        // Búsqueda por ID (convertimos ambos a string para comparar)
        // const idMatch = item.talamoChinaconexionRequestsId
        const referenceMatch = item.reference?.toString().includes(searchValue);

        return (
          nameMatch ||
          lastNameMatch ||
          documentMatch ||
          descriptionMatch ||
          referenceMatch
        );
      });

      setRows(resultSearch);
    } else {
      setRows(rowsResponse);
    }
  };

  const RefreshTable = (filterValues = values) => {
    axios
      .get(`${urlServices}payment-link/list-client-refunds-all`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let filteredData = response.data;

          // Usa filterValues en lugar de values
          if (filterValues.startLink && filterValues.endLink) {
            const fromDate = Moment(filterValues.startLink).format(
              "YYYY-MM-DD",
            );
            const toDate = Moment(filterValues.endLink).format("YYYY-MM-DD");

            filteredData = filteredData.filter((client) => {
              const clientDate = Moment(client.createdAt).format("YYYY-MM-DD");
              return clientDate >= fromDate && clientDate <= toDate;
            });
          }

          if (filterValues.clients) {
            filteredData = filteredData.filter(
              (client) => client.clientsId === filterValues.clients,
            );
          }

          let totalPendingValue = 0;

          let dataFinal = filteredData.map((data) => {
            const commissionPercentage = parseFloat(
              data.client?.percentage || 0,
            );
            const payTotal = parseFloat(data.total || 0);

            // Cálculo de la comisión
            const commission = (commissionPercentage * payTotal) / 100;

            // Cálculo del total a transferir (total - comisión)
            const transferAmount = payTotal - commission;

            totalPendingValue += transferAmount;
            return {
              ...data,
              commissionPayment: commission.toFixed(2),
              commissionPaymentTotal: transferAmount.toFixed(2),
            };
          });

          setRows(dataFinal);
          setRowsResponse(dataFinal);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    RefreshTable();
  }, [values.clients, values.startLink, values.endLink]);

  /*const handleSearch = () => () => {
    setAlert({ openAlert: false });

     if (!values.clients) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar un cliente",
      });
      return;
    }

    if (!values.startLink) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha inicial",
      });
      return;
    }

    if (!values.endLink) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha final",
      });
      return;
    }

    RefreshTable();
  };*/

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  // Manejar cambio de fecha inicial
  const handleDateStartChange = (date) => {
    setDateStart(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    if (dateEnd && dateEnd <= date) {
      setDateEnd(null);
      setValues((prev) => ({ ...prev, endLink: "" }));
    }

    setValues((prev) => ({
      ...prev,
      startLink: formattedDate,
    }));
    setShowStartCalendar(false);
  };

  const changeClients = (data) => {
    const newValues = {
      ...values,
      clients: data !== null ? data.id : null,
      clientsData: data !== null ? data : "",
    };

    setValues(newValues);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  // Manejar cambio de fecha final
  const handleDateEndChange = (date) => {
    setDateEnd(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    setValues((prev) => ({
      ...prev,
      endLink: formattedDate,
    }));
    setShowEndCalendar(false);
  };

  const changeClientsDeleteFilter = () => {
    const newValues = {
      ...values,
      clients: null,
      clientsData: "",
    };

    setValues(newValues);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  const changeCalendarDeleteFilter = () => {
    const newValues = {
      ...values,
      endLink: null,
      startLink: null,
    };

    setValues(newValues);
    setDateStart(false);
    setDateEnd(false);

    // Llama a RefreshTable con los nuevos valores inmediatamente
    RefreshTable(newValues);
  };

  const openViewValue = (data) => () => {
    setIdRow(data.row);
    setOpenView(true);
  };

  const handlePaidRefundsValue = (data) => () => {
    setIdRow(data.row);
    setOpenRefund(true);
  };

  const handleCloseNew = () => setOpenNew(false);
  const handleCloseRefund = () => setOpenRefund(false);
  const handleCloseView = () => setOpenView(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar({ open: false });
  };

  const handleDetails = (data) => () => {
    setIdRow(data.row);
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid xs={12} sm={12} md={12}>
        <Card
          sx={{ padding: "15px 20px", margin: { xs: "60px 0", sm: "10px 0" } }}
          variant="outlined"
        >
          {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
          {loader ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "20% 0" }}
                  />
                </center>
              </Grid>
            </Grid>
          ) : (
            <Fragment>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                  <div className={classes.cardTitleBlack}>
                    <List className={classes.iconFilter} /> Listado de
                    Reembolsos
                  </div>
                  <Alert severity="info">
                    Listado de todos los Reembolsos realizado por la
                    administración, solicitado por los clientes.
                  </Alert>
                </Grid>
                <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                  <div
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Aplicar filtros:
                  </div>
                </Grid>

                <Grid item xs={12} md={3} sx={{ mt: 1 }}>
                  <ClickAwayListener
                    onClickAway={() => setShowStartCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha inicial"
                        value={dateStart ? format(dateStart, "dd/MM/yyyy") : ""}
                        onClick={() => setShowStartCalendar(!showStartCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        size="small"
                      />
                      {showStartCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateStart}
                            onChange={handleDateStartChange}
                            locale={es}
                            color={blackColor}
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                </Grid>

                <Grid item xs={12} md={3} sx={{ mt: 1 }}>
                  <ClickAwayListener
                    onClickAway={() => setShowEndCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha final"
                        value={dateEnd ? format(dateEnd, "dd/MM/yyyy") : ""}
                        onClick={() => setShowEndCalendar(!showEndCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        disabled={!dateStart}
                        size="small"
                      />
                      {showEndCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateEnd}
                            onChange={handleDateEndChange}
                            locale={es}
                            color={blackColor}
                            minDate={
                              dateStart ? addDays(dateStart, 1) : undefined
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                  <b
                    style={{
                      fontSize: 10,
                      color: "red",
                      cursor: "pointer",
                      display: dateEnd ? "block" : "none",
                      marginTop: 5,
                    }}
                    onClick={changeCalendarDeleteFilter}
                  >
                    <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                  </b>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {/* Campo de filtro clients */}
                  <LoadClients
                    value={values.clientsData}
                    refresh={changeClients}
                  />
                  <b
                    style={{
                      fontSize: 10,
                      color: "red",
                      cursor: "pointer",
                      display: values.clients ? "block" : "none",
                      marginTop: 2,
                    }}
                    onClick={changeClientsDeleteFilter}
                  >
                    <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                  </b>
                </Grid>
                {/*<Grid item xs={12} sm={3} sx={{ mt: 1 }}>
                  <ButtonStyle0
                    style={{ fontSize: 12, width: 130, marginTop: 3 }}
                    onClick={handleSearch()}
                  >
                    Aplicar filtro
                  </ButtonStyle0>
                </Grid>*/}
                <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                  {/* Campo de búsqueda */}
                  <TextField
                    variant="outlined"
                    value={searchText}
                    onChange={handleSearchChange}
                    sx={{ width: 350, float: "right" }}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <Search
                          position="start"
                          style={{
                            color: "gray",
                            fontSize: 22,
                            marginRight: 10,
                          }}
                        />
                      ),
                    }}
                    placeholder="COD. o referencia, Cliente del hotel..."
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 12,
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <DataGrid
                        rows={rows}
                        columns={state.columns}
                        loading={loader}
                        initialState={{
                          pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                          },
                        }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        disableRowSelectionOnClick={true}
                        checkboxSelection={false}
                        rowHeight={140}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            display: "flex",
                            alignItems: "center", // Alineación vertical
                            // justifyContent: 'center', // Alineación horizontal
                            //wordWrap: 'break-word !important',
                            //whiteSpace: 'normal !important',
                          },
                          /* [`& .${gridClasses.columnHeaderTitle}`]: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          },*/
                        }}
                        getRowHeight={() => "auto"}
                        //autoHeights
                        autoWidth
                      />
                    </ThemeProvider>
                  </Box>
                </Grid>
              </Grid>
            </Fragment>
          )}
        </Card>
      </Grid>
      <Snackbar
        open={openSnackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
        >
          {openSnackbar.mensage}
        </Alert>
      </Snackbar>
      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity={alert.errorAlert === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {alert.mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      )}
      {openNew && (
        <NewLinkPaymentsAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openView && (
        <ViewLinkAdmin open={openView} exit={handleCloseView} id={idRow} />
      )}
      {openDetails && (
        <ViewsTrasactionsPayment
          open={openDetails}
          exit={handleCloseDetails}
          id={idRow}
        />
      )}

      <StatusRefundLinkAdmin
        open={openRefund}
        exit={handleCloseRefund}
        id={idRow}
        callBackRefresh={RefreshTable}
        admin={true}
      />
    </Grid>
  );
}
